import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Icon } from '../Elements';

import { settingsMap } from './helpers/configurates';

import classes from './QBRSentiment.module.scss';

const QBRSentiment = ({ sentiment, showIcon = true }) => {
  const settings =
    sentiment && sentiment in settingsMap
      ? settingsMap[sentiment]
      : settingsMap['Other'];

  return (
    <>
      {sentiment && sentiment !== '-' && sentiment !== 'NA' ? (
        <div className={classes.sentiment}>
          {showIcon ? (
            <Icon
              icon={settings.iconName}
              className={cn(classes.icon, settings.iconClass)}
              size="16px"
            />
          ) : (
            <div className={cn(classes.marker, settings.markerClass)} />
          )}
          {sentiment}
        </div>
      ) : (
        sentiment || 'NA'
      )}
    </>
  );
};

QBRSentiment.propTypes = {
  sentiment: PropTypes.string,
  showIcon: PropTypes.bool
};

export default QBRSentiment;
